import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UsuarioSesionDTO } from 'src/app/models/dtos/usuario-sesion-dto';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public usuario$: Observable<UsuarioSesionDTO> = null;


  constructor(private facadeSesionService: FacadeSesionService,) { }

  ngOnInit() {
    this.usuario$ = this.facadeSesionService.usuarioEnSesionService.obtenerUsuario();
  }

}
